
import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface AILocationAnalysisProps {
  address: string;
  setAddress: (value: string) => void;
  aiEngine: string;
  setAiEngine: (value: string) => void;
  onSearch: () => void;
  setShouldAnalyze: (value: boolean) => void;
  children: React.ReactNode;
}

export const AILocationAnalysis: React.FC<AILocationAnalysisProps> = ({
  address,
  setAddress,
  aiEngine,
  setAiEngine,
  onSearch,
  setShouldAnalyze,
  children
}) => {
  return (
    <div className="bg-secondary/50 backdrop-blur-lg border-2 border-primary rounded-lg shadow-lg shadow-purple-500/10 w-[50%] p-3 py-[24px] my-[8px] h-[560px]">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-semibold text-white">AI Location Analysis</h2>
        <div className="flex items-center gap-2">
          <span className="text-[12px] text-primary-light">Choose AI Engine:</span>
          <RadioGroup value={aiEngine} onValueChange={setAiEngine} className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <RadioGroupItem value="openai" id="openai" />
              <label htmlFor="openai" className="text-white text-[12px] cursor-pointer">OpenAI</label>
            </div>
            <div className="flex items-center gap-1">
              <RadioGroupItem value="deepseek" id="deepseek" />
              <label htmlFor="deepseek" className="text-white text-[12px] cursor-pointer">DeepSeek</label>
            </div>
          </RadioGroup>
        </div>
      </div>
      
      <div className="flex items-center gap-2 mb-3">
        <label className="text-white whitespace-nowrap">Address:</label>
        <Input 
          value={address} 
          onChange={e => {
            setAddress(e.target.value);
            setShouldAnalyze(false);
          }} 
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSearch();
            }
          }} 
          className="flex-1 bg-white text-black" 
          placeholder="Enter an address to analyze" 
        />
        <Button onClick={onSearch}>Search</Button>
      </div>
      
      <div className="flex flex-col gap-3">
        <div className="h-[420px] rounded-lg overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};
